import React, { useCallback, useEffect, useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsArrowDown, BsDownload } from "react-icons/bs";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import FileDownloader from "../../../../components/UI/Button/FileDownloader";
import ButtonImage from "../../../../components/UI/Button/ButtonImage";
import TablePagination from "../../../../components/UI/Table/TablePagination";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import DateTime from "../../../../components/Formatters/DateTime";

const Cell = (description) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{description}</Tooltip>} data-tag="allowRowEvents">
    <Button
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#858796",
        textDecoration: "none",
      }}
      variant="link"
      data-tag="allowRowEvents"
    >
      {description}
    </Button>
  </OverlayTrigger>
);

const acoesCell = (row) => {
  if (!row.documento || row.situacao === "Cancelado") {
    return (
      <ButtonImage
        className="btn-lg text-success pa-0 p-0"
        buttonImage={<BsDownload size="15" color="#888" />}
        tooltipImage="Não foi encontrado documento para baixar"
        onClick={() => {}}
      />
    );
  }

  return <FileDownloader binario={row.documento} tooltip="Visualizar Documento" />;
};

const columns = [
  {
    name: "Andamento",
    maxWidth: "19%",
    center: true,
    sortable: true,
    cell: (row) => <DateTime value={row.andamento} stringFormat="dd/MM/yyyy hh:mm:ss" />,
  },
  {
    name: "Atividade",
    selector: "atividade",
    maxWidth: "35%",
    sortable: true,
    cell: (row) => Cell(row.atividade),
  },

  {
    name: "Situação",
    selector: "situacao",
    maxWidth: "11%",
    center: true,
    sortable: true,
  },

  {
    name: "Usuário",
    selector: "usuario",
    maxWidth: "24%",
  },
  {
    name: "Ações",
    center: true,
    maxWidth: "1%",
    cell: acoesCell,
  },
];

const AndamentoAutoInfracaoEsp = ({ dadosAiEspecial }) => {
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(1);
  const setSelection = useState({})[1];

  const { request: requestAndamento, data, errors: error, isLoading } = useApiClient();

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  useEffect(() => {
    if (dadosAiEspecial) {
      const values = {
        SequencialAcaoFiscal: dadosAiEspecial.dadosOs.acaoFiscal,
        SequencialProdutoAcaoFiscal: dadosAiEspecial.sequencialAuto,
        pageSize,
        pageNumber,
      };
      requestAndamento(apiRoutes.fiscalizacao.autoinfracao.andamentoautoinfracaoesp, values);
    }
  }, [requestAndamento, dadosAiEspecial, pageSize, pageNumber]);

  useEffect(() => {
    if (data && data.result) {
      if (data.result.length && !data.result[0].totalRows) {
        console.error(`[DEV] A propriedade "totalRows" é obrigatória nos resultados paginados.`);
        return;
      }

      const preRows = data.result.map((item) => {
        const disabled = !(item.anexos?.length > 0);
        return { ...item, disabled };
      });

      setRows(preRows || []);
      setTotalRows(data.result.length ? data.result[0].totalRows : 0);
    }

    if (error) {
      toast.error(error.message);
    }
  }, [data, error]);

  return (
    <div style={{ width: "100%" }}>
      <DataTable
        noHeader
        keyField="sqAndamento"
        columns={columns}
        data={rows}
        progressPending={isLoading}
        noDataComponent="Nenhum registro para exibir"
        progressComponent={<TextSpinner />}
        defaultSortFieldId={1}
        sortIcon={<BsArrowDown />}
        sortable
        paginationTotalRows={totalRows}
        selectableRows={false}
        onSelectedRowsChange={(state) => {
          setSelection(state.selectedRows);
        }}
        pointerOnHover
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paginationComponent={TablePagination}
        paginationPerPage={pageSize}
      />
    </div>
  );
};

export default AndamentoAutoInfracaoEsp;
